import Modal from "./Modal";

export * from "./types";

export default Modal;
